
import { OC_PLUS_LOGO } from '@marketplace/config/ocplus.js'

export default {
    name: 'ModalBuyOcPlusCongratulations',

    data() {
        return {
            OC_PLUS_LOGO,
            modalData: {
                title: this.$t(
                    'headings.ocplus.buy_modal.congratulations_title',
                    {
                        ocPlusLogo: OC_PLUS_LOGO.bold.dark,
                    }
                ),
                description: this.$t(
                    'text.ocplus.buy_modal.congratulations_text'
                ),
                imageUrl: require('~assets/images/oc-plus/buy-oc-plus-congratulations.svg'),
            },
        }
    },
}
